import {api} from './requestGraphql'

const getProgramsList = async () => {
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        programs {
                            id
                            name
                            marginPercent
                            marginType
                            payout
                            price
                            currencyId
                            currencyAbbr
                            currencySymbol
                        }
                    }
                `
            }
        )

        return res.data.data.programs
    } catch (e) {
        console.error(e)
    }
}

const getPrograms = async ({limit, page, orderBy, orderDirectionAsc, filters}) => {
    const search = filters.search ? `"${filters.search}"` : '""';
    const name = filters.name ? `"${filters.name}"` : '""';
    const advertiser = filters.advertiser ? `"${filters.advertiser}"` : '""';
    const lastUpdatedBy = filters.lastUpdatedBy ? `"${filters.lastUpdatedBy}"` : '""';
    const currency = filters.currency ? `"${filters.currency}"` : '""';
    const payout = filters.payout ? `"${filters.payout}"` : '""';
    const price = filters.price ? `"${filters.price}"` : '""';
    const id = filters.id ? `"${filters.id}"` : '""';

    const order = orderBy ? `"${orderBy}"` : '"name"';
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getPrograms(
                            pagination: {
                                page: ${page},
                                limit: ${limit}
                            },
                            sorting: {
                                orderBy: ${order},
                                orderDirectionAsc: ${orderDirectionAsc}
                            }, 
                            filters: {
                              search: ${search}
                              name: ${name}
                              advertiser: ${advertiser}
                              lastUpdatedBy: ${lastUpdatedBy}
                              currency: ${currency}
                              payout: ${payout}
                              price: ${price}
                              id: ${id}
                            }
                        ){
                            programs {
                              id
                              name
                              advertiser
                              advertiserId
                              currency
                              payout
                              price
                              marginType
                              marginPercent
                              lastUpdatedBy
                              isRestricted
                              geos{
                                code
                                name
                                payout
                                price
                                margin_percent
                                device_type
                              }
                            },
                          filters {
                            name {
                              key
                              value
                            }
                            currency {
                              key
                              value
                            }
                            advertiser {
                              key
                              value
                            }
                            payout {
                              key
                              value
                            }
                            price {
                              key
                              value
                            }
                            lastUpdatedBy {
                                key
                                value
                            }
                          }
                        }
                    }
                `
            }
        );

        return res.data.data.getPrograms
    } catch (e) {
        console.error(e)
    }
};

const getProgramDetails = async (programId) => {
    try {

        const res = await api.post(
            '', {
                query: `
                    {
                        programDetails(programId:${programId}) {
                            geo
                            payout
                            price
                            countryName
                            margin
                            device_type
                        }
                    }
                `
            }
        )

        return res.data.data.programDetails

    } catch (e) {
        console.error(e)
    }
}

const campaignProgramOverride = async (data) => {
    try {
        const res = await api.post(
            '', {
                query: `
                mutation {
                    campaignProgramOverride(
                        campaignId:${data.campaignId}
                        programId:${data.programId}
                        oldProgramId:${data.oldProgramId}
                        affiliateId:${data.affiliateId}
                    )
                }
            `
            }
        )

        return res.data.data.campaignProgramOverride
    } catch (e) {
        console.error(e)
    }
}

const createProgram = async (data) => {
    try {
        const geos = data.geos;
        const geosFormat = JSON.stringify(geos).replace(/"/g, '\\"');
        const res = await api.post(
            '', {
                query: `
                      mutation{
                        saveProgram(
                          id: ${data.id}  
                          name: "${data.name}",
                          price: ${data.price},
                          payout: ${data.payout},
                          advertiserId: ${data.advertiserId},
                          advertiser: "${data.advertiser}",
                          currencyId: ${data.currencyId},
                          currency: "${data.currency}",
                          marginType: "${data.marginType}",
                          marginPercent: ${data.marginPercent},
                          lastUpdatedBy: "${data.lastUpdatedBy}",
                          isRestricted: ${data.isRestricted},
                          isBasedByExisting: ${data.isBasedByExisting},
                          geos: "${geosFormat}"
                        ){
                             id    
                              name
                              price
                              payout
                              advertiserId
                              currency
                              marginType
                              marginPercent
                              lastUpdatedBy
                              isRestricted
                              geos{
                                price
                                payout
                                code
                              }
                        }
                      }
                     `,
            },
        );

        if (res.data.errors) {
            throw new Error(res.data.errors[0].message);
        }

        return res.data.data.saveProgram;

    } catch (err) {
        console.error(err)
        throw err;
    }
}

const deleteProgram = async (id, email) => {
    try {
        const res = await api.post(
            '', {
                query: `
                  mutation{
                    deleteProgram(id: ${id}, email: "${email}")
                  }
                `,
            },
        );

        if (res.data.errors) {
            throw new Error(res.data.errors[0].message);
        }

        return res.data.data.deleteProgram;

    } catch (err) {
        console.error(err);
        throw err;
    }
}

const getProgramHistory = async (data) => {
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getProgramHistory(programId: ${data.id}) {
                            id    
                            user
                            date
                            action
                            field
                            changes
                        }
                    }
                `
            }
        );

        return res.data.data.getProgramHistory
    } catch (e) {
        console.error(e)
    }
};

const getProgramByCampaign = async (campaignId) => {
    try {

        const res = await api.post(
            '', {
                query: `
                    {
                        getProgramIdByCampaign(campaignId: ${campaignId}) {
                            programId
                            programOverride
                        }
                    }
                `
            }
        )

        return res.data.data.getProgramIdByCampaign;

    } catch (error) {

    }
}

const getProgramsCanNotBeDeleted = async () => {
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getProgramsCanNotBeDeleted 
                    }
                `
            }
        );

        return res.data.data.getProgramsCanNotBeDeleted
    } catch (e) {
        console.error(e)
    }
}

const setDefaultPrograms = async (defaultPrograms, affiliateId) => {
    let programs = JSON.stringify(defaultPrograms).replace(/"/g, '\\"')

    try {
        const res = await api.post(
            '', {
                query: `
                  mutation{
                    setDefaultPrograms(
                      programs:"${programs}",
                      affiliateId: ${affiliateId}
                    )
                  },
                `,
            }
        );

        let response = res.data.data.setDefaultPrograms
        return response
    } catch (e) {
        console.log(e)
    }
}

const getDefaultPrograms = async (affiliateId) => {

    try {
        const res = await api.post(
            '', {
                query: `
                  {
                      getDefaultPrograms(affiliateId: ${affiliateId}){
                        vertical
                        program
                  }
}
                `,
            }
        );

        let response = res.data.data.getDefaultPrograms
        return response
    } catch (e) {
        console.log(e)
    }
}

const getAllowedCountriesByOfferId = async (offerId) => {
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getAllowedCountriesByOfferId(offerId: ${offerId}) {
                            offerId
                            countries
                            isAllCountriesAllowed
                        }
                    }
                `
            }
        );

        return res.data.data.getAllowedCountriesByOfferId;

    } catch (error) {
        console.error("Error fetching allowed countries by offerId:", error);
        throw error;
    }
}

export default {
    getProgramsList,
    getProgramDetails,
    campaignProgramOverride,
    getPrograms,
    getProgramHistory,
    createProgram,
    deleteProgram,
    getProgramByCampaign,
    getProgramsCanNotBeDeleted,
    setDefaultPrograms,
    getDefaultPrograms,
    getAllowedCountriesByOfferId
}